import { gql } from '@apollo/client';

export const UPSERT_INDICATOR_FRAMEWORK = gql`
  mutation UpsertIndicatorFramework($input: UpsertIndicatorWorkspaceInput!) {
    indicatorFramework: upsertIndicatorWorkspace(input: $input) {
      id
    }
  }
`;
